import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';

import SoftwareApproval from './../components/SoftwareApproval';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    softwares: state.softwares,
    softwareRequest: state.softwareRequest,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SoftwareApproval);
